import { render, staticRenderFns } from "./WhereToStay.vue?vue&type=template&id=687f85bc&scoped=true&"
import script from "./WhereToStay.vue?vue&type=script&lang=js&"
export * from "./WhereToStay.vue?vue&type=script&lang=js&"
import style0 from "./WhereToStay.vue?vue&type=style&index=0&id=687f85bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f85bc",
  null
  
)

export default component.exports